import React from "react";
import { Nav, Service } from "../../Components/index";
import services from "../../assets/json/services.json";
import { Footer } from "../../Containers/index";
// import { Services } from "../../Containers/index";

import classes from "./Services.module.css";

function ServicesPage() {
  let serviceList = services.map((service, index) => {
    return (
      <Service
        key={index}
        title={service.title}
        text={service.text}
        src={service.icon}
        alt={service.title}
      />
    );
  });
  return (
    <section>
      <Nav />
      <div className={classes.ServicesContent}>
        <h2 className={classes.ServicesTitle}>
          <span>Our</span> Services
        </h2>

        <ul className={classes.ServicesList}>{serviceList}</ul>
        {/* <Services limitedServices={-1} showBtn={false} /> */}
      </div>
      <Footer />
    </section>
  );
}

export default ServicesPage;
